import { useQuery } from "@/api/utils/useQuery"
import { QueryResult } from "@/api/utils/types"
import { SoMessagesQueries } from "@/api/soMessages/queries"
import {
  IJiraIssue,
  IJiraIssuesPayload,
  IOpenIssues,
  IOpenIssuesPayload,
} from "@/models/jiraIssue/jiraIssue.types"
import {
  JiraIssueParser,
  OpenIncidentsParser,
} from "@/models/jiraIssue/jiraIssue.parser"

export interface IJiraIssuesService {
  getJiraIssue(issueId: string): QueryResult<IJiraIssue>
}

class JiraIssuesClass implements IJiraIssuesService {
  getJiraIssue(issueId: string): QueryResult<IJiraIssue> {
    return useQuery({
      ...SoMessagesQueries.getJiraIssueById.issue(issueId),
      parserFn: (rawData) => JiraIssueParser.toDomain(rawData),
    })
  }

  getOpenJiraIssues(payload: IOpenIssuesPayload): QueryResult<IOpenIssues> {
    return useQuery({
      ...SoMessagesQueries.openIssuesByPriority.issues(payload),
      parserFn: (rawData) => OpenIncidentsParser.toDomain(rawData),
    })
  }

  getJiraIssues(payload: IJiraIssuesPayload): QueryResult<IOpenIssues> {
    return useQuery({
      ...SoMessagesQueries.getJiraIssues.issues(payload),
      parserFn: (rawData) => OpenIncidentsParser.toDomain(rawData),
    })
  }
}

export const JiraIssuesService = new JiraIssuesClass()
